<template>
  <b-modal
    :active="true"
    :can-cancel="['escape', 'x', 'outside']"
    @close="onClose"
  >
    <div class="content">
      <div class="header">
        <h1 class="title">Add Comment</h1>
      </div>

      <RichTextEditor :headings="[]" v-model="comment" />

      <footer class="footer-buttons">
        <b-button label="Cancel" @click="onClose" type="is-danger" />
        <b-button label="Save" @click="onSave" type="is-success" />
      </footer>
    </div>
  </b-modal>
</template>

<script>
import RichTextEditor from '../../RichTextEditor';

export default {
  name: 'WIStepCommentModal',

  components: {
    RichTextEditor,
  },

  props: {
    initialComment: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      comment: this.initialComment,
    };
  },

  methods: {
    onClose() {
      this.$emit('close');
    },

    onSave() {
      this.$emit('save', { comment: this.comment });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  background: white;
  border-radius: 10px;
  padding: 20px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.header {
  display: flex;
  justify-content: space-between;
}

.footer-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
</style>
